var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 16,
    viewBox: "0 0 34 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 16,
    rx: 4,
    fill: "#311F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8459 4.0195L12.6339 12H11.1379L7.9259 4.0195H9.2569C9.3999 4.0195 9.5154 4.05433 9.6034 4.124C9.69507 4.19 9.7629 4.27617 9.8069 4.3825L11.5339 8.9805C11.5999 9.15283 11.6641 9.34167 11.7264 9.547C11.7924 9.74867 11.8529 9.96133 11.9079 10.185C11.9556 9.96133 12.0069 9.74867 12.0619 9.547C12.1206 9.34167 12.1829 9.15283 12.2489 8.9805L13.9649 4.3825C14.0016 4.29083 14.0657 4.20833 14.1574 4.135C14.2527 4.058 14.3701 4.0195 14.5094 4.0195H15.8459ZM18.2455 12H16.5845V4.0195H18.2455V12ZM22.6096 7.9905C23.1266 7.9905 23.5043 7.86583 23.7426 7.6165C23.9846 7.36717 24.1056 7.02617 24.1056 6.5935C24.1056 6.3955 24.0744 6.21583 24.0121 6.0545C23.9534 5.8895 23.8618 5.75017 23.7371 5.6365C23.6161 5.51917 23.4621 5.42933 23.2751 5.367C23.0881 5.30467 22.8663 5.2735 22.6096 5.2735H21.5646V7.9905H22.6096ZM22.6096 4.0195C23.1559 4.0195 23.6271 4.08367 24.0231 4.212C24.4228 4.34033 24.7509 4.52 25.0076 4.751C25.2643 4.97833 25.4531 5.24967 25.5741 5.565C25.6988 5.88033 25.7611 6.22317 25.7611 6.5935C25.7611 6.98583 25.6969 7.34517 25.5686 7.6715C25.4403 7.99783 25.2459 8.27833 24.9856 8.513C24.7253 8.74767 24.3971 8.931 24.0011 9.063C23.6051 9.19133 23.1413 9.2555 22.6096 9.2555H21.5646V12H19.9146V4.0195H22.6096Z",
    fill: "url(#paint0_linear_45191_162910)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45191_162910",
    x1: 27.5,
    y1: 11,
    x2: 9,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.6486a96bcce64c7f218d4d2eaf7f2d65.svg";
export { ForwardRef as ReactComponent };